import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Controller, useFormContext } from 'react-hook-form';

function FormItem({ Component, componentProps, children, name, transform }) {
  const { control, getValues, setValue, resetField, clearErrors } =
    useFormContext();
  return (
    <Box component="div">
      <Controller
        control={control}
        name={name}
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { error, isTouched },
        }) => (
          <>
            <Component
              {...componentProps}
              name={name}
              id={name}
              onChange={
                transform
                  ? (e) =>
                    onChange(
                      transform(
                        e,
                        getValues(),
                        setValue,
                        resetField,
                        clearErrors,
                      ),
                    )
                  : onChange
              }
              value={value || ''}
              onBlur={onBlur}
              inputRef={ref}
              error={!!error}
              errorMessages={error?.message}
            >
              {children}
            </Component>
          </>
        )}
      />
    </Box>
  );
}

FormItem.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string.isRequired,
  Component: PropTypes.any.isRequired,
  componentProps: PropTypes.any,
  transform: PropTypes.func,
};

FormItem.defaultProps = {
  children: <></>,
  componentProps: null,
  transform: null,
};

export default FormItem;
